import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ComponentsComponent } from './components.component';
import { WelcomeComponent } from './welcome/welcome.component';

const routes: Routes = [{
  path: '',  component: ComponentsComponent,
  children:[
    //{ path : '', redirectTo : 'mypage', pathMatch: 'full'},
    {
      path: 'mypage',
      loadChildren: () => import('./mypage/mypage.module').then(m => m.MypageModule)
    },
    {
      path: 'link',
      loadChildren: () => import('./link/link.module').then(m => m.LinkModule)
    },
    {
      path: 'account',
      loadChildren: () => import('./account/account.module').then(m => m.AccountModule)
    },
    { path: 'home', component: WelcomeComponent},
    {
      path: 'user',
      loadChildren: () => import('./user/user.module').then(m => m.UserModule)
    },
    {
      path: 'settle',
      loadChildren: () => import('./settle/settle.module').then(m => m.SettleModule)
    },
    {
      path: 'voc',
      loadChildren: () => import('./voc/voc.module').then(m => m.VocModule)
    },
    {
      path: 'event',
      loadChildren: () => import('./event/event.module').then(m => m.EventModule)
    }
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ComponentsRoutingModule { }
